var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-radio-group',{staticClass:"mt-0",attrs:{"disabled":_setup.compDisabled||_setup.compSkeleton,"hide-details":""},model:{value:(_setup.dvalue),callback:function ($$v) {_setup.dvalue=$$v},expression:"dvalue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }